import { useCallback, useEffect, useState } from 'react';
import { buyersApi } from '../services/referenceApi';
import type { BuyerSummary } from '../services/referenceApi';

type State = { status: 'loading' } | { status: 'found'; buyer: BuyerSummary } | { status: 'missing' } | { status: 'failed' };

/** The buyer named in the address, looked up in the list staff may work on; retry asks again after a failure. */
export function useBuyer(slug: string | undefined): State & { retry: () => void } {
  const [state, setState] = useState<State>({ status: 'loading' });
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading' });
    buyersApi
      .list()
      .then(({ data }) => {
        if (cancelled) return;
        const buyer = data.find((b) => b.slug === slug);
        setState(buyer ? { status: 'found', buyer } : { status: 'missing' });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'failed' });
      });
    return () => {
      cancelled = true;
    };
  }, [slug, attempt]);

  return { ...state, retry };
}
